<template>
    <div>
        <div class="text-body1 text-left">
            {{ field.label ?? '' }}
            <span v-if="field.required" class="text-negative" style="font-size: 1.5em;"><strong>*</strong></span>
        </div>
        <div v-if="field.sublabel" class="text-caption text-grey-7 text-left">
            {{ field.sublabel }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FieldHeader',
        props: {
            field: {
                type: Object,
                required: true,
            },
        },
    };
</script>